<template>
  <div class="bg-dark p-4">
    <b-container class="d-flex justify-content-center">
      <div class="col-lg-5 col-md-5 margin_bottom text-center mb-4">
        <a class="btn_luqei m-1" href="https://twitter.com/Luqei1">
          <img src="@/assets/twitter_jaune.png" width="36px" alt="">
        </a>
        <a class="btn_luqei m-1" href="https://www.youtube.com/channel/UCPWLh4HQx9To3418z-4uCzg?sub_confirmation=1">
          <img src="@/assets/youtube_jaune.png" width="36px" alt="">
        </a>
        <a class="btn_luqei m-1" href="https://www.facebook.com/luqei/">
          <img src="@/assets/facebook_jaune.png" width="36px" alt="">
        </a>
        <a class="btn_luqei m-1" href="https://www.linkedin.com/company/luqei/">
          <img src="@/assets/linkedin_jaune.png" width="36px" alt="">
        </a>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "footerApp"
}
</script>

<style scoped>
.btn_luqei:hover {
  position: relative;
  top: 2px;
}
</style>